import { useQuery } from '@tanstack/react-query';
import { membersService } from '../services/membersService';
import type { GetFamilyMembersParams } from '../types/members';

export const useFamilyMembers = (params?: GetFamilyMembersParams) => {
  return useQuery({
    queryKey: ['family-members', params],
    queryFn: () => membersService.getFamilyMembers(params),
    staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
    gcTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
  });
};

// Hook specifically for getting family members count
export const useFamilyMembersCount = () => {
  return useQuery({
    queryKey: ['family-members-count'],
    queryFn: async () => {
      const response = await membersService.getFamilyMembers({ limit: 1, directoryOnly: true }); // Get minimal data to get count
      return response.total || 0;
    },
    staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
    gcTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
  });
};